<template>
    <ob1-cards
        data-test-id="device-card"
        is-link
        class="full-height"
        :title="'Découvrir ' + currentVersion.brand + ' ' +currentVersion.name"
        :href="currentVersion.detailLink"
        data-oevent-category="selecteur_produit"
        :data-oevent-action="'bloc_' + currentVersion.name.split(' ').join('_')"
        :data-oevent-label="currentVersion.detailLink"
    >
        <div class="d-flex flex-column h-100 justify-content-between">
            <div class="selector-card-upper-part">
                <div class="position-absolute">
                    <div v-if="isTagIndisponible">
                        <ob1-tag
                            type="unavailable"
                            :label="model.status.label"
                        />
                    </div>
                    <div v-else-if="currentVersion.tag">
                        <ob1-tag :label="currentVersion.tag" />
                    </div>
                </div>
                <div class="d-flex flex-row pt-2 px-1">
                    <div class="img-mobile mx-1">
                        <!--/* Image */-->
                        <div class="img-container">
                            <selector-color-chips :colors="model.colors" />
                            <ob1-picture
                                v-if="currentVersion.image"
                                :visual="currentVersion.image"
                            />
                            <ob1-simple-image
                                v-if="currentVersion.imageOverlay"
                                :visual="currentVersion.imageOverlay"
                                class="img-overlay"
                                :css-classes="'img-network-compatibility'"
                            />
                        </div>
                    </div>
                    <div class="infos">
                        <div class="mobile-infos">
                            <h2 class="no-signature standard pb-0 my-0 fw-normal">
                                {{ currentVersion.brand }}<br>
                                <strong class="standard">{{ currentVersion.name }}</strong>
                            </h2>
                            <div
                                v-if="currentVersion.reviews"
                                class="mb-1"
                            >
                                <ob1-rating
                                    :average="currentVersion.reviews.average"
                                    :with-score="true"
                                    :rating-results-height="1.010"
                                    :font-size="0.875"
                                />
                            </div>

                            <div v-if="currentVersion.isRefurbished" class="mt-1">
                                <ob1-capsule :label="currentVersion.refurbishedLabel" is-context is-small />
                            </div>

                            <div
                                v-if="model.status && model.status.label && !isTagIndisponible"
                                class="mt-1"
                            >
                                <ob1-tag
                                    type="unavailable"
                                    :label="model.status.label"
                                    is-small
                                />
                            </div>
                        </div>
                        <div v-if="currentVersion.price" class="mt-1 infos-price">
                            <device-price
                                :multiple-price="hasMultiplePrice(currentVersion.price)"
                                :compact-price="true"
                                :total-price-with-promo="currentVersion.price.price.totalPriceWithPromo"
                                :total-price-without-promo="currentVersion.price.price.totalPriceWithoutPromo"
                                :monthly-amount-in-cents="currentVersion.price.price.monthlyPayment ? currentVersion.price.price.monthlyPayment.monthlyAmountInCents : null"
                                :monthly-duration="currentVersion.price.price.monthlyPayment ? currentVersion.price.price.monthlyPayment.duration : null"
                                :taeg-rate="currentVersion.price.price.monthlyPayment ? currentVersion.price.price.monthlyPayment.taegRate : null"
                                :generic-label="currentVersion.price.price.monthlyPayment ? currentVersion.price.price.monthlyPayment.genericLabel : null"
                                :loan-rate-zero-label="loanRateZeroLabel"
                                :is-cents-format="true"
                                :is-price-inversion-enabled="isPriceInversionEnabledForDevice(currentVersion.price.price)"
                            />
                        </div>
                    </div>
                </div>
                <!--/* Promo + odr + bonus reprise */-->
                <div v-if="currentVersion.price && currentVersion.price.advantageValues" class="infos-advantage p-1">
                    <advantage-bloc
                        :advantage-messages="advantageMessages"
                        :bonus-recovery="currentVersion.price.advantageValues.bonusRecovery"
                        :discount="currentVersion.price.advantageValues.discount"
                        :odr="currentVersion.price.advantageValues.odr"
                    />
                </div>
            </div>
        </div>
    </ob1-cards>
</template>

<script>
import AdvantageBloc from "../../fragments/AdvantageBloc";
import {ColorSorter} from "../../mixins/ColorSorter";
import DevicePrice from "../../../../common/components/ob1/DevicePrice.vue";
import SelectorColorChips from "./SelectorColorChips.vue";

export default {
    name: "SelectorCard",
    components: {DevicePrice, SelectorColorChips: SelectorColorChips, AdvantageBloc},
    mixins: [ColorSorter],
    props: {
        model: {
            type: Object,
            required: true
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        isPriceInversionEnabled: {
            type: Boolean,
            required: true
        },
        loanRateZeroLabel: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
        }
    },
    computed: {
        currentVersion: function () {
            return this.model.currentVersion;
        },
        isTagIndisponible() {
            return this.model.status && this.model.status.type === "INDISPONIBLE"
        }
    },
    methods: {
        hasMultiplePrice: function (displayPrice) {
            return displayPrice.price.multiplePrice || this.model.hasMultipleStartingPrice;
        },
        isPriceInversionEnabledForDevice: function (price) {
            return this.isPriceInversionEnabled && !!price?.monthlyPayment?.monthlyAmountInCents;
        }
    }
}
</script>
<style lang="scss">
//Pour ne pas avoir un décalage entre les étoiles oranges et grises
//En attendant de corriger par ob1
.ob1-rating .ob1-stars::after {
    top: 11%;
}
</style>
